import { createReducer, on } from '@ngrx/store';
import { UserDataApiActions } from '../actions/user-data-api.actions';
import { WeightHistoryData } from '../../../shared/models';
import { UserScoreResponse } from 'ngx-esprio-shared/lib/shared/models/account/responses/user-score-response.model';

export interface UserMetricsState {
  weightChangePercentage?: {
    weightChangePercentage: number;
    startDate: Date;
    endDate: Date;
  } | null;
  timeSnap?: WeightHistoryData | null;
  scoreDetails?: UserScoreResponse | null;
  dataAvailability: {
    hasBasicWebkData: boolean;
    hasSymptomsHistoryDataYesNo: boolean;
    hasSymptomsHistoryDataScale: boolean;
    hasGeneralHealthHistoryData: boolean;
  } | null;
}

const initialState: UserMetricsState = {
  weightChangePercentage: null,
  timeSnap: null,
  scoreDetails: null,
  dataAvailability: null,
};

export const userMetricsReducer = createReducer(
  initialState,
  on(UserDataApiActions.getUserWeightChangePercentageSuccess, (state, { payload }) => ({
    ...state,
    weightChangePercentage: payload,
  })),
  on(UserDataApiActions.getUserTimeSnapSuccess, (state, { payload }) => ({
    ...state,
    timeSnap: payload,
  })),
  on(UserDataApiActions.getUserScoreDetailsSuccess, (state, { payload }) => ({
    ...state,
    scoreDetails: payload,
  })),
  on(UserDataApiActions.checkDataAvailabilitySuccess, (state, { payload }) => ({
    ...state,
    dataAvailability: payload,
  })),
  on(UserDataApiActions.purgeUserData, (state) => ({
    ...state,
    weightChangePercentage: null,
    timeSnap: null,
    scoreDetails: null,
    dataAvailability: null,
  }))
);
